import { call, put, all } from 'redux-saga/effects';

import { getMessages } from '@api/messages';
import { fetchSavedFilingPeriod } from '@api/savedFilingPeriod';
import { intl } from '@helpers/intl';
import { messageListGetModel, messageListRequestModel } from '@models/messages';
import {
  messagesListGetFailureAction,
  messagesListGetSuccessAction,
} from '@store/messages/messagesList/messagesList.actions';
import { unreadMessageCountRequestAction } from '@store/user/user.actions';

export const handleGetMessages = function* ({ payload }) {
  try {
    const { savedFilingPeriod } = payload;

    let messagesResult;
    let savedFilingPeriodResult;

    if (savedFilingPeriod) {
      [messagesResult, savedFilingPeriodResult] = yield all([
        call(getMessages, messageListRequestModel(payload)),
        call(fetchSavedFilingPeriod, savedFilingPeriod),
      ]);
    } else {
      messagesResult = yield call(getMessages, messageListRequestModel(payload));
    }

    yield put(
      messagesListGetSuccessAction(messageListGetModel(messagesResult, savedFilingPeriodResult))
    );

    yield put(unreadMessageCountRequestAction());
  } catch (error) {
    const errorMessage =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'An unexpected error occurred, please try again.',
        id: 'global.notification.api-error-default',
      });

    yield put(messagesListGetFailureAction({ errorMessage }));
  }
};
